import { type ReactNode } from 'react'
import {
  StickyViewHeader,
  StickyViewHeaderMain,
} from '@/components/StickyViewHeader'
import { useScrollOffsets } from '@/hooks/element-hooks'
import styles from './JobListPage.module.css'

export interface JobListPageProps {
  heading: ReactNode
  children: ReactNode
}

export function JobListPage({ heading, children }: JobListPageProps) {
  const { connectRef: scrollRef, scrollYStart: scrollOffset } =
    useScrollOffsets()

  return (
    <div className={styles.root} ref={scrollRef}>
      <StickyViewHeader scrollOffset={scrollOffset} flush>
        <StickyViewHeaderMain>{heading}</StickyViewHeaderMain>
      </StickyViewHeader>

      <div className={styles.content}>{children}</div>
    </div>
  )
}
